"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/domains/post/post-item");
const constants_1 = require("@/constants");
/**
 * 글 목록. 카드를 격자로 늘어놓는다. 카드 전체가 글 상세로 가는 링크라 명령이 아닌 목록으로 읽히고, 각 링크가 저마다 Tab 순서를 갖는다.
 */
let PostList = class PostList extends lit_1.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'list');
    }
    render() {
        return (0, lit_1.html) `
      <slot @slotchange=${this.handleSlotChange}></slot>
    `;
    }
    handleSlotChange() {
        this.posts.forEach(post => post.setAttribute('role', 'listitem'));
    }
};
PostList.styles = (0, lit_1.css) `
    :host {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: var(--space-12) var(--space-8);
    }

    @media ${constants_1.MEDIA.narrow} {
      :host {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
  `;
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ flatten: true })
], PostList.prototype, "posts", void 0);
PostList = __decorate([
    (0, decorators_js_1.customElement)('mm-post-list')
], PostList);
exports.PostList = PostList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zdC1saXN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicG9zdC1saXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBd0U7QUFFeEUsK0NBQTRDO0FBQzVDLDJDQUFtQztBQUVuQzs7R0FFRztBQUVJLElBQU0sUUFBUSxHQUFkLE1BQU0sUUFBUyxTQUFRLGdCQUFVO0lBZ0J0QyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxNQUFNLENBQUMsQ0FBQTtJQUNuQyxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7MEJBQ1csSUFBSSxDQUFDLGdCQUFnQjtLQUMxQyxDQUFBO0lBQ0gsQ0FBQztJQUVPLGdCQUFnQjtRQUN0QixJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLFVBQVUsQ0FBQyxDQUFDLENBQUE7SUFDbkUsQ0FBQzs7QUE1Qk0sZUFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7O2FBT1IsaUJBQUssQ0FBQyxNQUFNOzs7OztHQUt0QixDQUFBO0FBQ3lDO0lBQXpDLElBQUEscUNBQXFCLEVBQUMsRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7dUNBQThCO0FBZDVELFFBQVE7SUFEcEIsSUFBQSw2QkFBYSxFQUFDLGNBQWMsQ0FBQztHQUNqQixRQUFRLENBOEJwQjtBQTlCWSw0QkFBUSJ9